// 비버 운영 모니터링 API 상수 (api-admin BeaverController)
// 동명 시군구(서울 중구 ↔ 부산 중구 등) 충돌 방지 위해 sido 필수
const BASE = "/api/v1/admin/beaver";

export default {
  BASE,
  NATIONAL: `${BASE}/national`,
  SIGUNGU: sigungu => `${BASE}/sigungu/${encodeURIComponent(sigungu)}`,
  AUGMENT: sigungu => `${BASE}/sigungu/${encodeURIComponent(sigungu)}/augment`,
};
